//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Get document name for export.
 * @param documentType (optional) 
 */
export function getExportName(documentId: number, documentType?: Types.DocumentType | undefined, config?: AxiosRequestConfig | undefined): Promise<string> {
    let url_ = getBaseUrl() + "/api/export/name/{documentId}?";
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
    if (documentType === null)
        throw new Error("The parameter 'documentType' cannot be null.");
    else if (documentType !== undefined)
        url_ += "documentType=" + encodeURIComponent("" + documentType) + "&";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetExportName,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetExportName?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetExportName(_response);
    });
}

function processGetExportName(response: AxiosResponse): Promise<string> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
    
        result200 = resultData200;
    
        return Promise.resolve<string>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<string>(null as any);
}

export function deferExportDocument(preparationInfo: Types.DocumentPreparationInfo, format?: Types.DocumentExportFormat | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FileResponse> {
    let url_ = getBaseUrl() + "/api/export/document?";
    if (format === null)
        throw new Error("The parameter 'format' cannot be null.");
    else if (format !== undefined)
        url_ += "format=" + encodeURIComponent("" + format) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeDocumentPreparationInfo(preparationInfo);

    let options_: AxiosRequestConfig = {
        responseType: "blob",
        ..._requestConfigDeferExportDocument,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigDeferExportDocument?.headers,
            "Content-Type": "application/json",
            "Accept": "application/octet-stream",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeferExportDocument(_response);
    });
}

function processDeferExportDocument(response: AxiosResponse): Promise<Types.FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200 || status === 206) {
        const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
        let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
        let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
        if (fileName) {
            fileName = decodeURIComponent(fileName);
        } else {
            fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
        }
        return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FileResponse>(null as any);
}

export function deferExportTemplate(preparationInfo: Types.TemplatePreparationInfo, format?: Types.DocumentExportFormat | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FileResponse> {
    let url_ = getBaseUrl() + "/api/export/template?";
    if (format === null)
        throw new Error("The parameter 'format' cannot be null.");
    else if (format !== undefined)
        url_ += "format=" + encodeURIComponent("" + format) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeTemplatePreparationInfo(preparationInfo);

    let options_: AxiosRequestConfig = {
        responseType: "blob",
        ..._requestConfigDeferExportTemplate,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigDeferExportTemplate?.headers,
            "Content-Type": "application/json",
            "Accept": "application/octet-stream",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeferExportTemplate(_response);
    });
}

function processDeferExportTemplate(response: AxiosResponse): Promise<Types.FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200 || status === 206) {
        const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
        let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
        let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
        if (fileName) {
            fileName = decodeURIComponent(fileName);
        } else {
            fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
        }
        return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FileResponse>(null as any);
}

export function deferExportDocumentTree(dto: Types.ExportDocumentTreeDto, format?: Types.DocumentExportFormat | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.FileResponse> {
    let url_ = getBaseUrl() + "/api/export/document-tree?";
    if (format === null)
        throw new Error("The parameter 'format' cannot be null.");
    else if (format !== undefined)
        url_ += "format=" + encodeURIComponent("" + format) + "&";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeExportDocumentTreeDto(dto);

    let options_: AxiosRequestConfig = {
        responseType: "blob",
        ..._requestConfigDeferExportDocumentTree,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigDeferExportDocumentTree?.headers,
            "Content-Type": "application/json",
            "Accept": "application/octet-stream",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeferExportDocumentTree(_response);
    });
}

function processDeferExportDocumentTree(response: AxiosResponse): Promise<Types.FileResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200 || status === 206) {
        const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
        let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
        let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
        if (fileName) {
            fileName = decodeURIComponent(fileName);
        } else {
            fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
        }
        return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.FileResponse>(null as any);
}
let _requestConfigGetExportName: Partial<AxiosRequestConfig> | null;
export function getGetExportNameRequestConfig() {
  return _requestConfigGetExportName;
}
export function setGetExportNameRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetExportName = value;
}
export function patchGetExportNameRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetExportName = patch(_requestConfigGetExportName ?? {});
}

let _requestConfigDeferExportDocument: Partial<AxiosRequestConfig> | null;
export function getDeferExportDocumentRequestConfig() {
  return _requestConfigDeferExportDocument;
}
export function setDeferExportDocumentRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeferExportDocument = value;
}
export function patchDeferExportDocumentRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeferExportDocument = patch(_requestConfigDeferExportDocument ?? {});
}

let _requestConfigDeferExportTemplate: Partial<AxiosRequestConfig> | null;
export function getDeferExportTemplateRequestConfig() {
  return _requestConfigDeferExportTemplate;
}
export function setDeferExportTemplateRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeferExportTemplate = value;
}
export function patchDeferExportTemplateRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeferExportTemplate = patch(_requestConfigDeferExportTemplate ?? {});
}

let _requestConfigDeferExportDocumentTree: Partial<AxiosRequestConfig> | null;
export function getDeferExportDocumentTreeRequestConfig() {
  return _requestConfigDeferExportDocumentTree;
}
export function setDeferExportDocumentTreeRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeferExportDocumentTree = value;
}
export function patchDeferExportDocumentTreeRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeferExportDocumentTree = patch(_requestConfigDeferExportDocumentTree ?? {});
}